import { internalFetch } from "./servicesHelpers";

const attachmentServices = {
    fetchAttachments: (token, workOrderNumber) => {
        const requestInit = {
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        var URI = `/fetchFileData/${workOrderNumber}`;
        return internalFetch(process.env.REACT_APP_FILEUPLOAD_API_URL + URI, requestInit);
    },

    updateAttachment: (token, fileInfo) => {
        const requestInit = {
            body: JSON.stringify(fileInfo),
            method: "PATCH",
            credentials: "include", // include, *same-origin, omit
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        var URI = `/updateFileData`;
        return internalFetch(process.env.REACT_APP_FILEUPLOAD_API_URL + URI, requestInit);
    },

    uploadAttachment: (token, fileInfo) => {
        const requestInit = {
            body: JSON.stringify(fileInfo),
            method: "POST",
            credentials: "include", // include, *same-origin, omit
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        var URI = `/uploadFileData`;
        return internalFetch(process.env.REACT_APP_FILEUPLOAD_API_URL + URI, requestInit);
    },

    // Not sure if this is hooked up properly yet
    uploadMultipleAttachments: (token, files) => {
        let body = {
            files: files.map((f) => ({
                fileName: f.fileName,
                fileType: f.fileType,
                data: f.data,
            })),
            relatedJobId: files[0].clickDispatchId,
            relatedSourceId: files[0].workOrderNumber,
        };
        const requestInit = {
            body: JSON.stringify(body),
            method: "POST",
            credentials: "include", // include, *same-origin, omit
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        var URI = `/uploadMultipleFiles`;
        return internalFetch(process.env.REACT_APP_FILEUPLOAD_API_URL + URI, requestInit);
    },

    removeAttachment: (token, fileToRemove) => {
        const requestInit = {
            method: "POST",
            credentials: "include", // include, *same-origin, omit
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        var URI = `/deleteFileData/${fileToRemove}`;
        return internalFetch(process.env.REACT_APP_FILEUPLOAD_API_URL + URI, requestInit);
    },
    removeAttachmentAuditActivity: (token, payload, userPein) => {
        const requestInit = {
            body: JSON.stringify(payload),
            method: "POST",
            credentials: "include",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        const URI = `/fileUploadAudit/delete`;
        const domain = process.env.REACT_APP_TASK_API_URL;
        return internalFetch(domain + URI, requestInit);
    },

    fileUploadAuditActivity: (token, payload, userPein) => {
        const requestInit = {
            body: JSON.stringify(payload),
            method: "POST",
            credentials: "include",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/fileUploadAudit/create`;
        const domain = process.env.REACT_APP_TASK_API_URL;
        return internalFetch(domain + URI, requestInit);
    },
    fileUpdateAuditActivity: (token, payload, userPein) => {
        const requestInit = {
            body: JSON.stringify(payload),
            method: "POST",
            credentials: "include",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/fileUploadAudit/update`;
        const domain = process.env.REACT_APP_TASK_API_URL;
        return internalFetch(domain + URI, requestInit);
    },
};

export default attachmentServices;
